import { AxiosRequestConfig } from "axios";
import { ReservationData } from "../types/reservas";
import { axiosInstance } from "./axiosInstance";

interface UpdateTourData {
  date?: number; // TourDayHour record ID (changed from string to number)
  hour?: string;
  participants?: number;
  grade_id?: number;
  state_id?: number;
  city?: string;
  institution?: string;
  cue?: string;
  tour_paths?: number[];
}

export const Reservas = {
  getAllToursCall: async () => {
    const response = await axiosInstance.get(`/auth/tours`);
    return response;
  },
  getAvailableDatesCall: async (id: number, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.get(
      `/auth/tours/check-availabilty-between-dates/${id}`,
      config
    );
    return response;
  },
  getAvailableHourCall: async (id: number, config?: AxiosRequestConfig) => {
    const response = await axiosInstance.get(
      `/auth/getWeekAvailability/${id}`,
      config
    );
    return response;
  },
  makeReservationCall: async (
    bodyParameters: ReservationData,
    config?: AxiosRequestConfig
  ) => {
    const response = await axiosInstance.post(
      `/auth/tours/make-reservation`,
      bodyParameters,
      config
    );
    return response;
  },
  getTourBook: async (id: number) => {
    const response = await axiosInstance.get(`/auth/tours/${id}`);
    return response;
  },
  updateTourBook: async (id: number, bodyParameters: UpdateTourData) => {
    const response = await axiosInstance.put(
      `/auth/tours/${id}`,
      bodyParameters
    );
    return response;
  },
};
